import { ConversationStep, Theme } from "../../interfaces";
import SendNewLead from "../../components/custom/SendNewLead";
import EscalationSteps from "../EscalationSteps";

const CSQuestionnaire = (theme: Theme) => {
  return [
    {
      id: "greetings",
      type: "bot",
      message: "Hey, I'm Parker - the feedback assistant",
      trigger: "feedback-intro",
    },
    {
      id: "feedback-intro",
      type: "bot",
      message: "My job is to get some feedback about your recent mortgage",
      trigger: "Rating",
    },
    {
      id: "Rating",
      type: "bot",
      message: "How did everything go?",
      options: [
        {
          label: "1 ⭐",
          value: "1",
          trigger: "What happened?",
        },
        {
          label: "2 ⭐",
          value: "2",
          trigger: "What happened?",
        },
        {
          label: "3 ⭐",
          value: "3",
          trigger: "What happened?",
        },
        {
          label: "4 ⭐",
          value: "4",
          trigger: "Posted feedback",
        },
        {
          label: "5 ⭐",
          value: "5",
          trigger: "Posted feedback",
        },
      ],
    },
    {
      id: "Posted feedback",
      type: "bot",
      message:
        "That's great, would you mind posting some feedback on our trustpilot page?",
      options: [
        {
          label: "Sure, lets do it",
          value: "Yes",
          trigger: "thankyou-end",
          action: {
            type: "redirect",
            link: theme.links?.trustPilotURL,
          },
        },
        {
          label: "No thanks",
          value: "No",
          trigger: "thankyou-end",
        },
      ],
    },
    {
      id: "What happened?",
      type: "bot",
      message: "Sorry to hear, do you mind if i ask what happened?",
      input: {
        type: "text",
      },
      trigger: "post-feedback-thanks",
    },
    {
      id: "post-feedback-thanks",
      type: "bot",
      message: "Thanks for the feedback.",
      trigger: "Resolution",
    },
    {
      id: "Resolution",
      type: "bot",
      message: "Is there anything we could do differently next time?",
      input: {
        type: "text",
      },
      trigger: "thankyou-end",
    },
    {
      id: "thankyou-end",
      type: "bot",
      message: "Thank you, I'll be sure to pass this feedback on.",
      trigger: "blank_send",
    },
    {
      id: "blank_send",
      type: "bot",
      component: <SendNewLead />,
      end: true,
    },
    ...EscalationSteps,
  ] as ConversationStep[];
};

export default CSQuestionnaire;
